<div *ngIf="offline" class="offline">
  <span>offline</span>
</div>

<router-outlet></router-outlet>

<app-chat-popup *ngIf="commonChatSevice.isChatVisible$ | async"></app-chat-popup>
